module.exports = __webpack_public_path__ + "static/media/waterLilyCover.a61ddbaf.svg";